import { createFileRoute } from "@tanstack/react-router";

import { AudienceMembersList } from "@/features/Audiences/AudienceMembers";
import { returnToAudienceSchema } from "@/features/Audiences/return";
import { audienceMemberSearchSchema } from "@/features/Audiences/types";

const membersSearchSchema = audienceMemberSearchSchema.extend(
  returnToAudienceSchema.shape,
);

export const Route = createFileRoute(
  "/_auth/people/$siteId/audiences/$audienceId/members/",
)({
  validateSearch: (raw) => membersSearchSchema.parse(raw),
  component: AudienceMembersRoute,
});

function AudienceMembersRoute() {
  const { siteId, audienceId } = Route.useParams();
  const search = Route.useSearch();

  return (
    <AudienceMembersList
      siteId={siteId}
      audienceId={audienceId}
      search={search}
    />
  );
}
